<div class="-mt-lg">
  @switch (type()) {
    @case ('jalon') {
      <app-jalon-detail-contenu [referentiel]="referentiel()" [peutModifier]="peutModifier()" />
    }
    @case ('étape') {
      <app-etape-detail-contenu
        [cartographie]="cartographie()"
        [referentiel]="referentiel()"
        [peutModifier]="peutModifier()"
        [showErrors]="showErrors()"
      />
    }
    @case ('module') {
      <app-module-detail-contenu
        [cartographie]="cartographie()"
        [referentiel]="referentiel()"
        [peutModifier]="peutModifier()"
      />
    }
    @case ('fin-parcours') {
      <app-fin-parcours-detail-contenu />
    }
    @case ('groupe-étapes-à-la-carte') {
      <app-groupe-etapes-detail-contenu [peutModifier]="peutModifier()" />
    }
  }
</div>
